import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { PaperPlaneTilt, Sparkle } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function PartnerInvite() {
  const empty = { to_email: "", cc: "", contact_name: "", company_name: "", subject: "", body: "" };
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState([]);
  const loadSent = () => api.get("/admin/partners/invites").then((r) => setSent(r.data)).catch(() => {});
  useEffect(() => { loadSent(); }, []);
  const fill = async () => {
    const r = await api.get(`/admin/partners/invite/template?contact_name=${encodeURIComponent(f.contact_name)}&company_name=${encodeURIComponent(f.company_name)}`);
    setF((s) => ({ ...s, ...r.data }));
  };
  const send = async () => {
    setBusy(true);
    try {
      await api.post("/admin/partners/invite", f);
      toast.success("Proposta inviata con il PDF personalizzato");
      setF(empty); loadSent();
    } catch (e) { const d = e.response?.data?.detail; toast.error(Array.isArray(d) ? d.map((x) => x.msg).join(" ") : d || "Errore"); } finally { setBusy(false); }
  };
  const ready = f.to_email && f.contact_name && f.company_name;
  return (
    <div className="rounded-2xl border border-line bg-canvas p-5" data-testid="partner-invite">
      <div className="font-serif text-lg text-ink mb-1">Invita un gestore</div>
      <div className="text-sm text-stone mb-3">Email pronta con la proposta PDF intestata alla sua azienda e il link di registrazione. Viene salvata nello storico di Cold Outreach.</div>
      <div className="grid md:grid-cols-3 gap-2">
        <Input placeholder="Nome referente" value={f.contact_name} onChange={(e) => setF({ ...f, contact_name: e.target.value })} data-testid="partner-invite-contact" />
        <Input placeholder="Azienda" value={f.company_name} onChange={(e) => setF({ ...f, company_name: e.target.value })} data-testid="partner-invite-company" />
        <Input placeholder="A: uno o più indirizzi, separati da virgola" value={f.to_email} onChange={(e) => setF({ ...f, to_email: e.target.value })} data-testid="partner-invite-email" />
      </div>
      <Input className="mt-2" placeholder="Cc: per conoscenza (facoltativo, separati da virgola)" value={f.cc} onChange={(e) => setF({ ...f, cc: e.target.value })} data-testid="partner-invite-cc" />
      <div className="text-xs text-stone mt-1">Tutti ricevono la stessa email con il PDF allegato. La nota di riservatezza è sempre inclusa.</div>
      <Button variant="outline" className="rounded-full mt-3" disabled={!f.contact_name || !f.company_name} onClick={fill} data-testid="partner-invite-fill"><Sparkle size={14} className="mr-1" />Prepara il testo</Button>
      {f.body && <>
        <Input className="mt-3" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="partner-invite-subject" />
        <Textarea rows={12} className="mt-2 text-sm" value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} data-testid="partner-invite-body" />
      </>}
      <Button className="rounded-full bg-ink text-canvas hover:bg-olive mt-3" disabled={!ready || busy} onClick={send} data-testid="partner-invite-send">
        <PaperPlaneTilt size={16} className="mr-1" />{busy ? "Invio…" : "Invia con PDF"}
      </Button>
      {!!sent.length && <div className="mt-4 text-xs text-stone space-y-1" data-testid="partner-invite-history">
        {sent.slice(0, 5).map((x) => <div key={x.id}>{new Date(x.sent_at).toLocaleDateString("it-IT")} · {x.company_name} · {x.to}</div>)}
      </div>}
    </div>
  );
}
